import {useEffect, useRef, useState} from "react";
import Chartjs from "chart.js/auto";
import {ChartConfiguration, ChartData, ChartOptions, ChartType} from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import dataLabelsPlugin from "chartjs-plugin-datalabels";

Chartjs.register(annotationPlugin);
Chartjs.register(dataLabelsPlugin);

export type ChartProps<T extends ChartType = ChartType> = {
  id: string;
  type: T;
  data?: ChartData<T>;
  options?: ChartOptions<T>;
};

export function Chart<T extends ChartType = ChartType>(
  props: ChartProps<T>
) {
  const {id, type, data, options} = props;

  const chartRef = useRef<HTMLCanvasElement | null>(null);

  const [chart, setChart] = useState<Chartjs<T> | undefined>(undefined);

  useEffect(() => {
    const context = chartRef.current?.getContext("2d");
    if (context) {
      const config: ChartConfiguration<T> = {
        type: type,
        data: {datasets: []} as ChartData<T>,
        options: {} as ChartOptions<T>
      };
      const newChart = new Chartjs(context, config);
      setChart(newChart);
    }
  }, [type, chartRef]);

  useEffect(() => {
    if (chart) {
      chart.data = data ?? {datasets: []};
      chart.options = options ?? ({} as ChartOptions<T>);
      chart.update();
    }
  }, [chart, data, options]);

  return <canvas id={id} ref={chartRef}/>;
}
